import constants from '@/app-configs/constants'

export default [
  {
    path: '/aksnonregistereddebtors/list',
    name: 'aks-non-registered-debtors',
    component: () => import('@/views/aks/NonRegisteredDebtors.vue'),
    meta: {
      pageTitle: 'DEBTIA_AKS_NON_REGISTERED_DEBTORS',
      breadcrumb: [
        {
          text: 'DEBTIA_AKS_NON_REGISTERED_DEBTORS',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
      companyOnly: true,
    },
  },
]
